import { useState, ChangeEvent, FormEvent } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft, Save } from "lucide-react";
import { useAuthStore } from "../features/auth/authStore";
import { useToast } from "../components/ToastProvider";
interface FormData {
  first_name: string;
  last_name: string;
  phone: string;
  email: string;
}
export default function EditProfileScreen() {
  const navigate = useNavigate();
  const { user } = useAuthStore();
  const { showToast } = useToast();
  const [formData, setFormData] = useState<FormData>({
    first_name: user?.first_name || "",
    last_name: user?.last_name || "",
    phone: user?.phone || "",
    email: user?.email || "",
  });
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    try {
      setIsLoading(true);
      console.log("Updated Profile:", formData);
      showToast("Profile updated successfully", "success");
      navigate(-1);
    } catch (error) {
      showToast("Failed to update profile", "error");
    } finally {
      setIsLoading(false);
    }
  };
  return (
    <div className="bg-gray-50 pb-8 md:bg-transparent md:max-w-2xl md:mx-auto">
      <div className="bg-white px-5 pt-5 pb-4 shadow-sm rounded-b-3xl md:rounded-3xl mb-6">
        <div className="flex items-center gap-4">
          <button
            onClick={() => navigate(-1)}
            className="w-10 h-10 border rounded-xl flex items-center justify-center"
          >
            <ArrowLeft size={18} />
          </button>
          <div>
            <h1 className="text-lg font-bold text-gray-900">Edit Profile</h1>
            <p className="text-sm text-gray-400">
              Update your account information
            </p>
          </div>
        </div>
      </div>
      <div className="px-5 md:px-0">
        <form onSubmit={handleSubmit} className="space-y-5">
          <div className="bg-white rounded-3xl border border-gray-100 shadow-sm p-5 space-y-4">
            <input
              name="first_name"
              value={formData.first_name}
              onChange={handleChange}
              className="w-full h-12 px-4 rounded-2xl border"
            />
            <input
              name="last_name"
              value={formData.last_name}
              onChange={handleChange}
              className="w-full h-12 px-4 rounded-2xl border"
            />
            <input
              name="phone"
              value={formData.phone}
              onChange={handleChange}
              className="w-full h-12 px-4 rounded-2xl border"
            />
            <input
              name="email"
              value={formData.email}
              onChange={handleChange}
              className="w-full h-12 px-4 rounded-2xl border"
            />
          </div>
          <button
            type="submit"
            disabled={isLoading}
            className="w-full h-12 bg-[#44B6CE] text-white rounded-2xl flex items-center justify-center gap-2"
          >
            <Save size={18} />
            <span>{isLoading ? "Saving..." : "Save"}</span>
          </button>
        </form>
      </div>
    </div>
  );
}
